import styled from "@emotion/styled";
import { useWallet } from "@solana/wallet-adapter-react";
import { darkGrey2, lightGreen, lightGreenTransp } from "@stepfinance/react";
import { Button } from "antd";
import type { BaseButtonProps } from "antd/lib/button/button";
import React from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useConnectedWallet } from "../../hooks/wallet/useConnectedWallet";
import { shortenAddress } from "../../utils/utils";
import { activeWalletIcon, WatchedWalletIcon } from "../Icons";

export const CurrentUserBadge: React.FC = () => {
  const { watching } = useEnrichedWallet();
  const wallet = useConnectedWallet();
  const walletProviderInfo = useWallet();

  if (!wallet) {
    return null;
  }

  return (
    <>
      <UserBadge onClick={() => {}}>
        {watching ? (
          <WatchedWalletIcon />
        ) : walletProviderInfo.wallet?.adapter ? (
          activeWalletIcon(walletProviderInfo.wallet?.adapter)
        ) : null}
        <span>{shortenAddress(`${wallet.publicKey}`)}</span>
      </UserBadge>
    </>
  );
};

const UserBadge = styled(Button)<BaseButtonProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  max-width: 150px;
  height: 32px;
  background: ${darkGrey2};
  border-radius: 8px;
  padding: 5px 10px;
  border: 1px solid ${darkGrey2};
  svg {
    width: 20px;
    height: 20px;
    align-self: center;
  }
  img {
    width: 20px;
    align-self: center;
  }
  span {
    color: ${lightGreen};
  }
  &:hover {
    border: 1px solid ${lightGreenTransp};
    background: ${darkGrey2};
  }
  &:active,
  &:focus {
    border: 1px solid ${lightGreen};
  }
`;
